import React, { FC } from 'react';
import Icon from 'src/common/components/IconDS22';
import styles from './LocationFAQs.module.scss';

export type LocationFAQsProps = {
  /**
   * The corresponding text for each title
  */
  children: React.ReactNode;
  /**
   * The title text to display
   */
  title: string;
};

const LocationFAQs: FC<LocationFAQsProps> = ({
  children,
  title,
}) => (
  <details
    className={styles.root}
  >
    <summary className={styles.summary}>
      <span className={styles.title}>{title}</span>
      <Icon
        id="caret-down"
        size="m"
        className={styles.icon}
      />
    </summary>
    <div className={styles.content}>
      {children}
    </div>
  </details>
);

export default LocationFAQs;
